export default "\n<app-img [src]=\"src\"></app-img>";